import PropTypes from 'prop-types';

export const DisplayGridColumnPropType = PropTypes.shape({
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  render: PropTypes.func.isRequired,
  width: PropTypes.number,
  minWidth: PropTypes.number,
  pinned: PropTypes.bool,
  sorted: PropTypes.oneOf([undefined, 'ascending', 'descending']),
  nonsortable: PropTypes.bool,
  index: PropTypes.number.isRequired,
});
